import { getDateTimeWithoutTimezone, safeFormat } from '@/v2/utils/convert'

const getHour = datetime =>
  safeFormat(getDateTimeWithoutTimezone(datetime), 'hh:mm aaa')

// An automated reply is Outgoing but carries no user: nobody on the team typed
// it. `automated` is the field the API sends; the `user` fallback covers any
// other authorless outgoing message so a null can never reach `.fullName`.
export const getSentAt = (type, createdAt, user, automated = false) => {
  const hour = getHour(createdAt)

  if (type === 'Reminder') return `Automated • ${hour}`
  if (type !== 'Outgoing') return hour

  return automated || !user?.fullName
    ? `Automated • ${hour}`
    : `${user.fullName} • ${hour}`
}
